import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";

export const Footer = () => {
  const [config, setConfig] = useState({});
  const [ventures, setVentures] = useState([]);

  useEffect(() => {
    api.get("/content/config").then((r) => setConfig(r.data)).catch(() => {});
    api.get("/content/ventures").then((r) => setVentures(r.data)).catch(() => {});
  }, []);

  const socials = Object.entries(config.socials || {}).filter(([, v]) => v);

  return (
    <footer data-testid="site-footer" className="border-t border-white/[0.06] bg-midnight">
      <div className="container-ek grid gap-12 py-16 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            {config.logo_url ? (
              <span className="inline-block rounded-xl bg-white px-2.5 py-1.5">
                <img src={config.logo_url} alt="Ekavrix Tech Ventures logo" className="h-9 w-auto max-w-[150px] object-contain" />
              </span>
            ) : (
              <>
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-to-br from-violet to-teal font-display text-lg font-bold text-white">E</span>
                <span className="font-display text-xl font-bold text-mist">{config.wordmark || "Ekavrix"}</span>
              </>
            )}
          </div>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-400">
            {config.company_name || "Ekavrix Tech Ventures"} — digital products, marketing expertise and consumer experiences, built around real needs.
          </p>
          {config.contact_email && (
            <a href={`mailto:${config.contact_email}`} data-testid="footer-email" className="mt-4 inline-block text-sm text-teal transition-colors hover:text-teal-hover">
              {config.contact_email}
            </a>
          )}
          {config.legal_name && (
            <p className="mt-4 text-xs text-slate-500">
              {config.legal_name}
              {config.registration_details ? ` · ${config.registration_details}` : ""}
            </p>
          )}
          {socials.length > 0 && (
            <div className="mt-4 flex gap-4">
              {socials.map(([k, v]) => (
                <a key={k} href={v} target="_blank" rel="noopener noreferrer" className="text-xs uppercase tracking-widest text-slate-400 transition-colors hover:text-teal">{k}</a>
              ))}
            </div>
          )}
        </div>
        <div className="md:col-span-2">
          <h3 className="eyebrow mb-4">Company</h3>
          <ul className="space-y-2.5 text-sm text-slate-400">
            <li><Link to="/about" className="transition-colors hover:text-mist">About</Link></li>
            <li><Link to="/ventures" className="transition-colors hover:text-mist">Ventures</Link></li>
            <li><Link to="/solutions" className="transition-colors hover:text-mist">Solutions</Link></li>
            <li><Link to="/affiliate" className="transition-colors hover:text-mist">Affiliate Partnerships</Link></li>
            <li><Link to="/partnerships" className="transition-colors hover:text-mist">Partnerships</Link></li>
            <li><Link to="/contact" className="transition-colors hover:text-mist">Contact</Link></li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <h3 className="eyebrow mb-4">Ventures</h3>
          <ul className="space-y-2.5 text-sm text-slate-400">
            {ventures.map((v) => (
              <li key={v.slug}><Link to={`/ventures/${v.slug}`} className="transition-colors hover:text-mist">{v.name}</Link></li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-2">
          <h3 className="eyebrow mb-4">Legal</h3>
          <ul className="space-y-2.5 text-sm text-slate-400">
            <li><Link to="/privacy" className="transition-colors hover:text-mist">Privacy</Link></li>
            <li><Link to="/terms" className="transition-colors hover:text-mist">Terms</Link></li>
            <li><Link to="/admin" className="text-slate-600 transition-colors hover:text-slate-400">Owner Login</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/[0.06] py-6">
        <div className="container-ek flex flex-col items-center justify-between gap-3 text-xs text-slate-500 sm:flex-row">
          <span>© {new Date().getFullYear()} {config.company_name || "Ekavrix Tech Ventures"}. All rights reserved.</span>
          <span>Ventures shown are introduced by Ekavrix; availability is confirmed individually.</span>
        </div>
      </div>
    </footer>
  );
};
